/** @file MOUNT_INVALID reasons shared by runtime equip and the compiler's mount bake (§5.9). */

/** `params.reason` of a MOUNT_INVALID error; the same words as format's validateDoc mount rules. */
export const MOUNT_REASONS = {
  /** The item has no handle to put on the socket. */
  noHandle: 'a mounted attachment needs a handle',
  /** Skinned meshes follow their influence bones, never a socket. */
  skinned: 'skinned meshes cannot be mounted',
} as const;
